<template>
  <v-dialog
    v-model="enableDialog"
    width="600"
    persistent
  >
    <v-card>
      <v-card-title>
      </v-card-title>
      <v-card-text>
        <h3>{{ message }}</h3>
        <h3>再度ログインしてください。</h3>
      </v-card-text>
      <v-card-actions>
        <v-btn
          block
          color="error"
          x-large
          @click="moveButtonClickEvent"
        >
          ログインに戻る
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "AuthorizationErrorDialog",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('authorizationErrorDialog', {
      enableDialog: 'show',
      message: 'message',
    })
  },
  watch: {},
  created() {},
  methods: {
    ...mapActions('authorizationErrorDialog', {
      closeDialog: 'hide'
    }),
    moveButtonClickEvent () {
      this.closeDialog()
      this.$router.replace({ name: 'DriverSessions' }, () => {})
    },
  }
}
</script>

<style scoped lang="scss">

</style>
